import { cn } from "@/lib/utils";

const STYLES = {
  valid: "bg-[#E8F5E9] text-[#1B5E20] dark:bg-[#1B3E20] dark:text-[#81C784]",
  expiring_soon: "bg-[#FFF8E1] text-[#B78103] dark:bg-[#3E2723] dark:text-[#FFD54F]",
  expired: "bg-[#FFEBEE] text-[#B71C1C] dark:bg-[#4A121A] dark:text-[#E57373]",
  missing: "bg-[#F3E5F5] text-[#4A148C] dark:bg-[#2A1B3D] dark:text-[#CE93D8]",
  reported: "bg-[#E3F2FD] text-[#0D47A1] dark:bg-[#0D274A] dark:text-[#64B5F6]",
  acknowledged: "bg-[#E8EAF6] text-[#283593] dark:bg-[#1A1F4A] dark:text-[#9FA8DA]",
  in_progress: "bg-[#E0F7FA] text-[#006064] dark:bg-[#002F35] dark:text-[#4DD0E1]",
  awaiting_part: "bg-[#FFF3E0] text-[#E65100] dark:bg-[#3D1E03] dark:text-[#FFB74D]",
  resolved: "bg-[#E8F5E9] text-[#2E7D32] dark:bg-[#1B3E20] dark:text-[#A5D6A7]",
  ready_to_drive: "bg-[#E8F5E9] text-[#1B5E20] dark:bg-[#1B3E20] dark:text-[#81C784]",
  under_maintenance: "bg-[#FFF8E1] text-[#B78103] dark:bg-[#3E2723] dark:text-[#FFD54F]",
  optional: "bg-secondary text-muted-foreground",
  active: "bg-[#E8F5E9] text-[#1B5E20] dark:bg-[#1B3E20] dark:text-[#81C784]",
  in_maintenance: "bg-[#FFF8E1] text-[#B78103] dark:bg-[#3E2723] dark:text-[#FFD54F]",
  out_of_service: "bg-[#FFEBEE] text-[#B71C1C] dark:bg-[#4A121A] dark:text-[#E57373]",
  disposed: "bg-secondary text-muted-foreground",
  overdue: "bg-[#FFEBEE] text-[#B71C1C] dark:bg-[#4A121A] dark:text-[#E57373]",
  due_soon: "bg-[#FFF8E1] text-[#B78103] dark:bg-[#3E2723] dark:text-[#FFD54F]",
  scheduled: "bg-[#E3F2FD] text-[#0D47A1] dark:bg-[#0D274A] dark:text-[#64B5F6]",
  none: "bg-secondary text-muted-foreground",
  critical: "bg-[#FFEBEE] text-[#B71C1C] dark:bg-[#4A121A] dark:text-[#E57373]",
  high: "bg-[#FFF3E0] text-[#E65100] dark:bg-[#3D1E03] dark:text-[#FFB74D]",
  medium: "bg-[#E3F2FD] text-[#0D47A1] dark:bg-[#0D274A] dark:text-[#64B5F6]",
  low: "bg-secondary text-muted-foreground",
  info: "bg-[#E3F2FD] text-[#0D47A1] dark:bg-[#0D274A] dark:text-[#64B5F6]",
  warning: "bg-[#FFF8E1] text-[#B78103] dark:bg-[#3E2723] dark:text-[#FFD54F]",
};

const LABELS = { puc: "PUC", tax: "Road Tax", optional: "Optional", ready_to_drive: "Ready to Drive" };

export function StatusBadge({ status, label, className, testId }) {
  const text = label || LABELS[status] || (status || "").replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
  return (
    <span data-testid={testId || `status-badge-${status}`} className={cn("inline-flex items-center whitespace-nowrap rounded-full px-2.5 py-0.5 text-xs font-medium", STYLES[status] || "bg-secondary text-muted-foreground", className)}>
      {text}
    </span>
  );
}
